import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "../TiterForm/titer.css";
import { ToastContainer, toast } from "react-toastify";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import Wrapper from "../../components/UI/Wrapper";
import "../../pages/SalesMasterPages/PriceCalculator/PriceCalculator.css";

const CheckHistoryDetails = () => {
  const location = useLocation();
  const relocation_id = location.state?.relocation_id;
  const version_no = location.state?.version_no;
  const baseAPI = process.env.REACT_APP_API_URL;

  const [details, setDetails] = useState([]);
  const [estHistory, setEstHistory] = useState([]); // 🔹 new API data
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const storedToken = JSON.parse(localStorage.getItem("token"));

        // 🔹 1️⃣ Fetch Relocation History Details
        const response1 = await axios.get(
          `${baseAPI}userget/GetRelocationHistoryDetails?relocation_id=${relocation_id}&version_no=${version_no}`,
          {
            headers: { Authorization: `Bearer ${storedToken}` },
          }
        );

        if (response1.data?.data?.length > 0) {
          setDetails(response1.data.data);
          setError("");
        } else {
          setError("No relocation details found.");
        }

        // 🔹 2️⃣ Fetch Estimate History Details
        const response2 = await axios.get(
          `${baseAPI}userget/GetEstHistoryDetails?relocation_id=${relocation_id}&version_no=${version_no}`,
          {
            headers: { Authorization: `Bearer ${storedToken}` },
          }
        );

        if (response2.data?.data?.length > 0) {
          setEstHistory(response2.data.data[0]);
        } else {
          console.warn("No estimate history found.");
        }
      } catch (err) {
        // console.error(err);
        setError("");
      }
    };

    if (relocation_id && version_no) {
      fetchDetails();
    }
  }, [relocation_id, version_no, baseAPI]);

  return (
    <>
      <div className="app-container-LeadList estimate-page-colSize">
        <MiniDrawer />
        <div
          className="container-fluid container-viewLeadDetails"
          style={{
            padding: "6rem 1rem 1rem 1rem",
            transition: "all 0.3s ease-in-out",
          }}
        >
          <ToastContainer />
          <div className="country-header">
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                <b>Estimate History</b> | <HomeOutlinedIcon /> &gt;
                <span style={{ fontSize: "20px" }}> Estimate History Detail</span>
              </h1>
            </div>
          </div>

          <Wrapper className="LeadDetails">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h3>
                  Estimate History <b> {relocation_id}_{version_no} </b>
                </h3>
              </div>
            </div>
          </Wrapper>
          <br></br>

          <Wrapper
            className="LeadDetails"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              width: "100%",
              minHeight: "80vh",
              padding: "2rem 0",
              boxSizing: "border-box",
            }}
          >
            <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",
                  borderRadius: "12px",
                }}
              >
                <tr style={{ border: "0.4px solid lightgray" }}>
                  <th style={{ textAlign: "left", width: "12%" }}>Buying: </th>
                  <td style={{ width: "13%" }}>
                    {estHistory?.buying ?? "-"}
                  </td>
                  <th style={{ textAlign: "left", width: "12%" }}>
                    Due Carrier:{" "}
                  </th>
                  <td style={{ width: "13%" }}>
                    {estHistory?.due_carrier ?? "-"}
                  </td>
                  <th style={{ textAlign: "left", width: "12%" }}>
                    Other Charges:{" "}
                  </th>
                  <td style={{ width: "13%" }}>
                    {estHistory?.other_charges ?? "-"}
                  </td>
                  <th style={{ textAlign: "left", width: "12%" }}>
                    Amount in AED (If Any):{" "}
                  </th>
                  <td style={{ width: "13%" }}>{estHistory?.amount_in_aed ?? "-"}</td>
                </tr>
                <tr style={{ border: "0.4px solid lightgray" }}>
                  <th style={{ textAlign: "left", width: "12%" }}>Total: </th>
                  <td
                    style={{
                      textAlign: "left",
                      fontWeight: "bold",
                      width: "13%",
                    }}
                  >
                    {estHistory?.amount_in_inr ?? "-"}
                  </td>
                  <th style={{ textAlign: "left", width: "12%" }}>
                    GST:{" "}
                  </th>
                  <td style={{ width: "13%" }}>
                    {estHistory?.total_gst ?? "-"}
                  </td>

                  <th style={{ textAlign: "left", width: "12%" }}>
                    Discount (Incl. GST):{" "}
                  </th>
                  <td style={{ width: "13%" }}>
                    {estHistory?.adjustment ?? "-"}
                  </td>
                  <th style={{ textAlign: "left", width: "12%" }}>
                    Discount Base (Excl. GST):{" "}
                  </th>
                  <td style={{ width: "13%" }}>{estHistory?.adjustmentBase ?? "-"}</td>
                </tr>

                <tr style={{ border: "0.4px solid lightgray" }}>

                  <th style={{ textAlign: "left", width: "12%" }}>
                    Discount GST (18%):{" "}
                  </th>
                  <td style={{ width: "13%" }}>{estHistory?.adjustmentGST ?? "-"}</td>
                  <th style={{ textAlign: "left", width: "12%" }}>
                    Total After Discount (in round off) :{" "}
                  </th>
                  <td
                    style={{
                      textAlign: "left",
                      fontWeight: "bold",
                      width: "13%",
                    }}
                  >
                    {estHistory?.finalAfterAdjustment ?? "-"}
                  </td>
                  <th style={{ textAlign: "left", width: "12%" }}>
                    Payment Gateway Charges ({estHistory?.paymentPercent}%):{" "}
                  </th>
                  <td style={{ width: "13%" }}>{estHistory?.paymentGatewayCharges ?? "-"}</td>
                  <th style={{ textAlign: "left", width: "12%" }}>
                    Final Total After Gateway Charges (rounded):{" "}
                  </th>
                  <td style={{ textAlign: "left", fontWeight: "bold", width: "13%", }}>{estHistory?.finalAfterGateway ?? "-"}</td>
                </tr>
              </table>
            </div>
          </Wrapper>

          <br></br>
          <Wrapper
            className="LeadDetails"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              width: "100%",
              minHeight: "80vh",
              padding: "2rem 0",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                width: "100%",
                background: "#fff",
                borderRadius: "10px",
              }}
            >
              {error && <p style={{ color: "red" }}>{error}</p>}

              {details.length > 0 ? (
                <div className="ViewLeadDetails">
                  <div className="container-fluid">
                    <div style={{ overflowX: "auto" }}>
                      <table
                        border="1"
                        width="100%"
                        style={{
                          borderCollapse: "collapse",
                          textAlign: "center",
                          fontSize: "14px",
                          minWidth: "800px",
                        }}
                      >
                        <thead>
                          <tr style={{ backgroundColor: "#f8f9fa" }}>
                            <th style={{ width: "3%" }}>S No.</th>
                            <th style={{ width: "15%" }}>Description</th>
                            <th style={{ width: "18%" }}>Scope of Service</th>
                            <th style={{ width: "7%" }}>Quantity</th>
                            <th style={{ width: "10%" }}>Rate (INR)</th>
                            <th style={{ width: "10%" }}>Taxable Amount</th>
                            <th style={{ width: "10%" }}>GST Charges</th>
                            <th style={{ width: "10%" }}>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {details.map((item, index) => (
                            <tr
                              key={index}
                              style={{ borderBottom: "0.4px solid lightgray" }}
                            >
                              <td>{index + 1}</td>
                              <td>{item.description}</td>
                              <td>{item.scope_of_service}</td>
                              <td>{item.quantity}</td>
                              <td>{item.amount_in_inr}</td>
                              <td>
                                {item.total_amount
                                  ? item.total_amount.toFixed(2)
                                  : "0.00"}
                              </td>
                              <td>{item.gst_price}</td>
                              <td>
                                {item.total ? item.total.toFixed(2) : "0.00"}
                              </td>
                            </tr>
                          ))}

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : (
                !error && <p>Loading details...</p>
              )}
            </div>
          </Wrapper>
        </div>
      </div>
    </>
  );
};

export default CheckHistoryDetails;

{
  /* <table className="history-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Quantity</th>
              <th>Amount (INR)</th>
              <th>GST Rate</th>
              <th>GST Price</th>
              <th>Total</th>
              <th>Scope of Service</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {details.map((item, index) => (
              <tr key={index}>
                <td>{item.description}</td>
                <td>{item.quantity}</td>
                <td>{item.amount_in_inr}</td>
                <td>{item.gst_rate}%</td>
                <td>{item.gst_price}</td>
                <td>{item.total}</td>
                <td>{item.scope_of_service}</td>
                <td>{new Date(item.created_date).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table> */
}
